
import React from 'react';
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface EventDetailsAccordionHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  extraContent?: React.ReactNode;
}

export const EventDetailsAccordionHeader = ({
  icon: Icon,
  title,
  subtitle,
  extraContent
}: EventDetailsAccordionHeaderProps) => {
  return (
    <div className="flex items-center gap-4 w-full">
      <div className="relative">
        <Icon className="w-5 h-5" />
      </div>
      <div className="flex-1">
        <span>{title}</span>
        {subtitle && (
          <p className="text-sm font-normal text-muted-foreground">{subtitle}</p>
        )}
      </div>
      {extraContent}
    </div>
  );
};
